import { FIELDS_OF_LAW_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'

import query from '../graphql/fieldsOfLaw.graphql'
import { FieldsOfLawQuery, FieldsOfLawQueryVariables } from '../interfaces'

export const getFieldsOfLaw = async (variables: FieldsOfLawQueryVariables): Promise<FieldsOfLawQuery> =>
  request<FieldsOfLawQuery, FieldsOfLawQueryVariables>(FIELDS_OF_LAW_ENDPOINT, query, variables)
